import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApptextRepository} from '../repositories/apptext.repository';

import {Apptext} from '../model/model';

@Injectable()
export class ApptextService {

  constructor(private _apptextRepository: ApptextRepository) { }

  public getApptexts(): Observable<Array<Apptext>> {
    const apptextObservable: Observable<Array<Apptext>> = this._apptextRepository.getApptexts();

    apptextObservable.subscribe((apptexts) => {
      this._setCachedApptexts(apptexts);
    });

    return apptextObservable;
  }

  public getCachedApptexts(): Observable<Array<Apptext>> {
    return this._apptextRepository.getCachedApptexts();
  }

  private _setCachedApptexts(apptexts: Array<Apptext>): Observable<void> {
    return this._apptextRepository.setCachedApptexts(apptexts);
  }

}
